import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import MaintenancePart from './maintenance-part';
import MaintenancePartDetail from './maintenance-part-detail';
import MaintenancePartUpdate from './maintenance-part-update';
import MaintenancePartDeleteDialog from './maintenance-part-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={MaintenancePartUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={MaintenancePartUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={MaintenancePartDetail} />
      <ErrorBoundaryRoute path={match.url} component={MaintenancePart} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={MaintenancePartDeleteDialog} />
  </>
);

export default Routes;
